/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-28 12:17:31
 * @LastEditTime: 2022-01-28 12:53:17
 * @LastEditors: zhao - 🍉
 * @Description: 惠市宝市场平台
 * @FilePath: /zhzj-admin/src/services/hsbMarketPlatform.js
 */

import request from "../utils/request"


/**
 * 分页查询-惠市宝分账规则
 * @param {{ current: 0, pageSize: 0, keyword: string }} params
 * @returns {Promise<Axios>} 
 */
export function fetchHSBMarketPlatformRuleList (params) {
    return request({
        url: '/platform/hsbMarketPlatform/findHsbAccountingRulePage',
        method: 'post',
        params
    })
}

/**
 * 获取详情-惠市宝分账规则
 * @param {{ id: 0 }} params
 * @returns {Promise<Axios>} 
 */
 export function fetchHSBMarketPlatformRuleGet (params) {
    return request({
        url: '/platform/hsbMarketPlatform/getHsbAccountingRuleById',
        method: 'post',
        params
    })
}

/**
 * 同步数据-惠市宝分账规则
 * @param {-} params
 * @returns {Promise<Axios>} 
 */
export function fetchHSBMarketPlatformRuleSyncData (params) {
    return request({
        url: '/platform/hsbMarketPlatform/syncAccountingRules',
        method: 'post',
        params
    })
}

/**
 * 分页查询-惠市宝商户信息
 * @param {{ current: 0, pageSize: 0, keyword: string }} params
 * @returns {Promise<Axios>} 
 */
export function fetchHSBMarketPlatformMerchantList (params) {
    return request({
        url: '/platform/hsbMarketPlatform/findHsbMerchantInfoPage',
        method: 'post',
        params
    })
}


/**
 * 获取详情-惠市宝商户信息
 * @param {{ id: 0}} params
 * @returns {Promise<Axios>} 
 */
export function fetchHSBMarketPlatformMerchantGet (params) {
    return request({
        url: '/platform/hsbMarketPlatform/getHsbMerchantInfoById',
        method: 'post',
        params
    })
}


/**
 * 同步数据-惠市宝商户信息
 * @param {-} params
 * @returns {Promise<Axios>} 
 */
export function fetchHSBMarketPlatformMerchantSyncData (params) {
    return request({
        url: '/platform/hsbMarketPlatform/syncGatherByenquireMkMrchOrder',
        method: 'post',
        params
    })
}





// WEBPACK FOOTER //
// ./src/services/HSBMarketPlatform.js